const DOCUMENT = 'DISTRICTS_';

const actions = {
  LOAD: DOCUMENT + 'LOAD',
  LOAD_FORM_DATA: DOCUMENT + 'LOAD_FORM',
  LOAD_FORM_DATA_SUCCESS: DOCUMENT + 'LOAD_FORM_DATA_SUCCESS',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  PROCESS_ACTION: DOCUMENT + 'PROCESS_ACTION',
  PROCESS_ACTION_SUCCESS: DOCUMENT + 'PROCESS_ACTION_SUCCESS',
  PROCESS_ACTION_FAILURE: DOCUMENT + 'PROCESS_ACTION_FAILURE',

  loadData: data => ({
    type: actions.LOAD,
    payload: data,
  }),

  loadFormData: data => ({
    type: actions.LOAD_FORM_DATA,
    payload: data,
  }),

  loadFormDataSuccess: data => ({
    type: actions.LOAD_FORM_DATA_SUCCESS,
    payload: data,
  }),

  loadDataSuccess: data => ({
    type: actions.LOAD_SUCCESS,
    payload: data,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),

  onProcessAction: data => ({
    type: actions.PROCESS_ACTION,
    payload: data,
  }),

  onProcessActionSuccess: data => ({
    type: actions.PROCESS_ACTION_SUCCESS,
    payload: data,
  }),

  onProcessActionFailure: data => ({
    type: actions.PROCESS_ACTION_FAILURE,
    payload: data,
  }),
};

export default actions;
